import { observer } from 'mobx-react-lite'
import { useHotkey } from '@/hooks/keyboard-hooks'
import { BubbleLayoutContext } from '@/features/messaging/components/ConversationView/Messages/List/MessageGroup'
import type { JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { JobConversationContainer } from '@/features/jobs/details/components/JobConversationContainer'
import {
  ChatPopover,
  ChatPopoverHeaderActions,
} from '@/features/jobs/details/components/ChatPopover'

export interface ChatPopoverContainerProps {
  vm: JobDetailsViewModel
}

/**
 * Open state is the job's Communication tab, which existing "open chat" paths
 * already set.
 */
export const ChatPopoverContainer = observer(function ChatPopoverContainer({
  vm,
}: ChatPopoverContainerProps) {
  useHotkey(['Escape'], () => vm.isChatOpen && vm.closeChat())

  if (!vm.isChatOpen || !vm.canChat) {
    return null
  }

  return (
    <ChatPopover
      title={vm.heading.title}
      onClose={vm.closeChat}
      headerActions={<ChatPopoverHeaderActionsContainer vm={vm} />}
    >
      <BubbleLayoutContext.Provider value>
        <JobConversationContainer
          vm={vm}
          showDocumentTabOnUpload={false}
          hideHeader
        />
      </BubbleLayoutContext.Provider>
    </ChatPopover>
  )
})

const ChatPopoverHeaderActionsContainer = observer(
  function ChatPopoverHeaderActionsContainer({
    vm,
  }: ChatPopoverContainerProps) {
    return (
      <ChatPopoverHeaderActions
        canJoinCall={vm.consultationVm.canJoinRoom}
        isJoinCallPending={vm.consultationVm.roomVm.join.pending}
        onJoinCall={vm.consultationVm.roomVm.join}
        hasConversation={vm.hasConversation}
        isMuted={vm.isConversationMuted}
        onToggleMute={vm.conversationVm.toggleMute}
        canDownloadConversation={vm.canDownloadConversation}
        onDownloadConversation={vm.conversationVm.downloadConversation}
      />
    )
  },
)
